
/**
 * 并发执行 tasks 指定的异步任务，并保证按照 tasks 的顺序返回结果
 * @param {Array<() => Promise<any>>} tasks
 */
export function concurrentTasks(tasks, maxConcurrent = 3) {
	// 任务总量
	const taskCount = tasks.length;

	// 已经完成的任务，但是还没通知的
	const staged = [];

	// 所有的任务的通知方法
	const subscriptons = [];

	// 生成所有任务的 Promise，通知方法写入到 subscriptions 中，在 flush 的时候 resolve
	const promises = tasks.map(() => new Promise((resolve, reject) => {
		subscriptons.push({ resolve, reject });
	}));

	// 当前并发量
	let concurrent = 0;

	// 下一个任务的索引
	let nextIndex = 0;

	// 已经通知完成的任务的索引
	let flushIndex = 0;

	// 根据当前并发量开始任务，占满并发为止
 	function next() {
		while (concurrent < maxConcurrent && nextIndex < taskCount) {
			const taskIndex = nextIndex++;
			tasks[taskIndex]().then(
				(result) => finish(taskIndex, result),
				(err) => throws(taskIndex, err),
			);
			concurrent++;
		}
	}

	// 有任务完成之后，并发量递减，并暂存通知到 staged
	// 为了保证顺序，这里不能马上通知，调用 flush 方法处理通知逻辑，并开启下一个任务
	function finish(index, result) {
		concurrent--;
		staged.push({
			index,
			result,
		});
		flush();
		next();
	}

	function throws(index, err) {
		subscriptons[index].reject(err);
	}

	// flushIndex 是接下来该通知的任务索引
	// staged 是有序的，把所有可以 flush 的往下通知
	function flush() {
		staged.sort((a, b) => a.index - b.index);
		let nextFlushIndex = flushIndex;
		while (staged[0] && nextFlushIndex === staged[0].index) {
			subscriptons[nextFlushIndex].resolve(staged.shift().result);
			// console.log('flush', nextFlushIndex);
			nextFlushIndex++;
		}
		flushIndex = nextFlushIndex;
	}

	next();

	let consumeIndex = 0;
	return {
		next() {
			return promises[consumeIndex++];
		}
	}
}



// WEBPACK FOOTER //
// ./lib/helpers/concurrentTasks.js